import { ISize } from '@shared/definitions';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getImgSize } from './getImgSize';

export const isImgSizeCorrect = (file: File, maxImgRes: number): Observable<boolean> => {
  return getImgSize(URL.createObjectURL(file)).pipe(
    map((size: ISize) => size.width <= maxImgRes && size.height <= maxImgRes)
  );
};
